import * as yup from 'yup'

import { trimmedInputValues } from '../utils'


const buyerPODetails = {
    poSource : "",
    clientPONum : "",
    poDocDate : "",
    poReceivedDate : ""
}

const buyerPOSchema = yup.object().shape({
    poSource: yup.string().required('This Field is required'),
    clientPONum: yup.string().when("poSource", {
        is : poSource => poSource === "Normal",
        then : () => yup.string()
                .transform((value) => trimmedInputValues(value))
                .required('This Field is required'),
        otherwise : () => yup.string().nullable()
    }),
    poDocDate: yup.string().when("poSource", {
        is : poSource => poSource === "Normal",
        then : () => yup.string()
            .transform((value) => trimmedInputValues(value))
            .required('This Field is required'),
        otherwise : () => yup.string().nullable()
    }),
    poReceivedDate: yup.string().required('This Field is required')
})


export { buyerPODetails, buyerPOSchema }

